import { Box, Typography, Container } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import FactoryIcon from "@mui/icons-material/Factory";
import PowerIcon from "@mui/icons-material/Power";
import WaterIcon from "@mui/icons-material/Water";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const industries = [
  { title: "Power Generation", icon: <PowerIcon /> },
  { title: "Data Centers", icon: <FactoryIcon /> },
  { title: "Oil & Gas", icon: <OilBarrelIcon /> },
  { title: "Hospitals", icon: <LocalHospitalIcon /> },
  { title: "Manufacturing Units", icon: <BuildIcon /> },
  { title: "Water Treatment Plants", icon: <WaterIcon /> },
];

export default function IndustriesWeServe() {
  return (
    <Box sx={{ py: 8, background: "#f5f7ff" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          textAlign="center"
          fontWeight={800}
          sx={{ color: brandBlue, mb: 5 }}
        >
          Industries We Serve
        </Typography>

        {/* Flexbox layout */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "center" },
            gap: 3,
          }}
        >
          {industries.map((item, i) => (
            <Box
              key={i}
              sx={{
                width: { xs: "45%", sm: "30%", md: "16%" },
                background: "#fff",
                borderRadius: 3,
                p: 3,
                textAlign: "center",
                boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                },
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  background: brandRed,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 12px",
                  color: "#fff",
                  fontSize: 35,
                }}
              >
                {item.icon}
              </Box>

              <Typography fontWeight={600} sx={{ color: brandBlue }}>
                {item.title}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
